import { Logger, LoggerService } from '@Shared/logger';
import { IScreen, ScreenType } from '../models';
import { UIScreenOptions } from '@Modules/ui_module/_models';
import { UI_CONST } from '@Modules/ui_module/display';
import { Form } from '@Modules/ui_module/components';
import { Alert } from '@Modules/ui_module/components/alert/alert.component';

export class Screen implements IScreen {
  private BaseLogger: Logger = LoggerService.createLogger('Screen');

  private _screenType: ScreenType;
  get ScreenType(): ScreenType {
    return this._screenType;
  }

  protected _html: string;
  protected _screenOptions: UIScreenOptions;
  protected _alert: Alert;
  get Alert(): Alert {
    return this._alert;
  }
  //protected _hasForm: boolean = false;
  protected _formSubmitHandler;
  protected _form?: Form;
  get Form(): Form {
    return this._form;
  }

  constructor() {
    this.BaseLogger.trace('****  CTOR ****');
    // Initialize any properties or methods if needed
  }
  show(): void {
    this.BaseLogger.trace('show called');
    this.updateHtml();
  }
  close(): void {
    this.BaseLogger.trace('close called');
    if (this._formSubmitHandler) {
      this._formSubmitHandler();
    }
    // Implement the logic to close the screen
    // For example, you might want to hide the screen or remove it from the DOM
  }

  protected handleForm(): void {
    this.BaseLogger.trace('handleForm');
    this._form = new Form(this._screenOptions.formOptions);
    this._alert = new Alert();
  }

  private updateHtml(): void {
    this.BaseLogger.trace('updateHtml');
    const screenBody = document.querySelector(UI_CONST.screenBody);
    if (!screenBody) {
      console.error("Element with class 'mng-screen-body' not found.");
      return;
    }

    const screenTitle = document.querySelector(UI_CONST.screenTitle);
    if (screenTitle) {
      screenTitle.innerHTML = this._screenOptions?.title ?? '';
    }
    screenBody.innerHTML = this._html ?? '';
  }
}
